import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Navbar from '../layout/Navbar';
import { Link, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { search, clearErrors } from '../../actions/companyActions';
import {
  getHomeImages
} from '../../actions/homeImageActions';
import classnames from 'classnames';
import isEmpty from '../../validation/is-empty';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      errors: {},
    };
    this.props.clearErrors();
  }

  componentDidMount() {
    this.props.getHomeImages();
    document.title = this.props.intl.formatMessage({ id: 'home.title' });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.errors !== state.errors) {
      return { errors: props.errors };
    }
    return null;
  }


  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onSubmit = (e) => {
    e.preventDefault();
    const searchData = {
      search: this.state.search,
      locale: this.props.locale.lang
    }

    this.props.search(searchData, this.props.history);
  };

  render() {
    const { homeImages } = this.props.homeImage;

    let listOfItems, listOfImages;

    if (isEmpty(homeImages) || this.props.homeImage.loading) {
      listOfItems = (
        <li data-target="#main-slide" data-slide-to="0" className="active"></li>
      )
      listOfImages = (
        <div className="carousel-item image-cover active" style={{ backgroundColor: "#444444" }} />
      )
    } else {
      listOfItems = [];
      listOfImages = [];
      for (let i = 0; i < homeImages.length; i++) {
        if (i === 0) {
          listOfItems.push(
            <li data-target="#main-slide" data-slide-to="0" key={homeImages[i]._id} className="active"></li>
          );
          listOfImages.push(
            <div className="carousel-item image-cover active" key={homeImages[i]._id} style={{ backgroundImage: `url(${homeImages[i].photo})` }} />
          );
        } else {
          listOfItems.push(
            <li data-target="#main-slide" data-slide-to={i} key={homeImages[i]._id}></li>
          );
          listOfImages.push(
            <div className="carousel-item image-cover " key={homeImages[i]._id} style={{ backgroundImage: `url(${homeImages[i].photo})` }} />
          );
        }

      }
    };
    return (
      <div>
        <Navbar />
        <div id="main-slide" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            {listOfItems}
          </ol>
          <div className="carousel-inner">
            <div className="carousel-caption d-md-block">
              <div className="search-container">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <h4 className="intro-sub-heading">
                        <FormattedMessage id="home.secondline" />
                      </h4>
                      <h2>
                        <FormattedMessage id="home.firstline" />
                      </h2>
                      <div className="row">
                        <div className="col-lg-6 col-md-8 col-xs-6 offset-lg-3 offset-md-2">
                          <div className="content">
                            <form onSubmit={this.onSubmit}>
                              <div className="search-add">
                                <div className="form-group">
                                  <FormattedMessage id="home.searchInCatalog">
                                    {(searchInCatalog) => (
                                      <input
                                        className={classnames('form-control-search', {
                                          'is-invalid': this.state.errors.search,
                                        })}
                                        type="text"
                                        placeholder={searchInCatalog}
                                        onChange={this.onChange}
                                        value={this.state.search}
                                        name="search"
                                      />
                                    )}
                                  </FormattedMessage>
                                  <div className="arrow-left" />
                                  <button type="submit" className="search-btn">
                                    <span className="lni-search" />
                                  </button>
                                </div>
                              </div>
                            </form>
                            {this.state.errors && <div className="d-block invalid-feedback">{this.state.errors.search}</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {listOfImages}

          </div>
          <a className="carousel-control-prev" href="#main-slide" role="button" data-slide="prev">
            <span className="carousel-control" aria-hidden="true"><i className="lni-chevron-left"></i></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#main-slide" role="button" data-slide="next">
            <span className="carousel-control" aria-hidden="true"><i className="lni-chevron-right"></i></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
        <section className="section-padding">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title-header text-center">
                  <p>
                    <FormattedMessage id="home.posio" />
                  </p>
                  <h2 className="section-title">
                    <FormattedMessage id="home.servicesAndCompanies" />
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-sm-12 mb-4">
                <div className="text-center">
                  <h2 className="mb-2">
                    <FormattedMessage id="home.catalog" />
                  </h2>
                  <p>
                    <FormattedMessage id="home.catalogParagraph" />
                  </p>
                  <Link to="/catalog" className="btn btn-common mt-2">
                    <FormattedMessage id="home.catalogButton" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-sm-12 mb-4">
                <div className="text-center">
                  <h2 className="mb-2">
                    <FormattedMessage id="home.product" />
                  </h2>
                  <p>
                    <FormattedMessage id="home.productParagraph" />
                  </p>
                  <Link to="/products" className="btn btn-common mt-2">
                    <FormattedMessage id="home.productButton" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

Home.propTypes = {
  locale: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  search: state.search,
  locale: state.locale,
  homeImage: state.homeImage,
  errors: state.errors
});

export default connect(mapStateToProps, {
  search, clearErrors, getHomeImages,
})(withRouter(injectIntl(Home)));
